import React from 'react'

const Footer = () => {
    return (
        <div className="footer dash_footer">
           
        </div>
    )
}

export default Footer